<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white flex-wrap" style="padding: 28px 0; gap: 16px;">
            <div class="d-flex align-items-center" style="gap: 16px;">
              <div class="header-icon-wrap">
                <i class="mdi mdi-table" style="font-size: 20px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Enrollee Deactivation Tool</h4>
                <small style="opacity: .8;">Verify enrollees before they are deleted from the agency</small>
              </div>
            </div>
            <div class="d-flex" style="gap: 10px;">
              <button class="btn btn-outline-light btn-sm" @click="getData">
                <i class="fe fe-plus mr-1"></i> Get Due for De-activation
              </button>
              <button class="btn btn-outline-light btn-sm" @click="filterparams = !filterparams">
                <i class="fe fe-filter mr-1"></i> Filter Deactivated
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- Filter Card -->
        <div class="card table-card shadow mb-4" v-show="filterparams">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-sliders" style="font-size:13px;"></i></div>
            <h6 class="mb-0 font-weight-bold text-white">Filter Parameters</h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1">Enrollee ID</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filter_field.id_card_number"
                  placeholder="ID/XXX/XXXXX"
                />
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1">Select Program</label>
                <select class="form-control" v-model="filter_field.sector">
                  <option
                    :value="sector"
                    v-for="sector in sectors"
                    :key="sector"
                  >
                    {{ sector }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>Start Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filter_field.from"
                />
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>End Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filter_field.to"
                />
              </div>

              <div class="col-md-12 pt-3 border-top">
                <div class="d-flex flex-wrap" style="gap:10px;">
                  <button class="btn btn-submit px-4" @click="getDeleted">
                    <i class="fe fe-filter mr-1"></i> Filter
                  </button>

                  <button class="btn btn-outline-dark">
                    <download-excel
                      :data="info.data"
                      :fields="json_fields"
                      type="xls"
                      :escapeCsv="false"
                      :name="'Deleted Data' + '.xls'"
                    >
                      <i class="fe fe-file-text mr-1"></i> Export Excel
                    </download-excel>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-7">
            <div class="card table-card shadow mb-4">
              <div class="card-body pb-0">
                <p class="h5 mb-0">
                  <i class="mdi mdi-checkbox-intermediate mr-1"></i> Data Info
                  <span class="text-primary">{{ info.meta.total }}</span>
                </p>
              </div>
              <div class="table-responsive">
                <table class="table align-td-middle mb-0">
                  <thead class="table-head">
                    <tr>
                      <th class="table-th">Type</th>
                      <th class="table-th">Full Name</th>
                      <th class="table-th">DOB</th>
                      <th class="table-th">Sector</th>
                      <th class="table-th">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="table-row" v-for="ins in info.data" v-bind:key="ins.id">
                      <td>{{ ins.account_type }}</td>
                      <td class="font-weight-bold">{{ ins.full_name }}</td>
                      <td>
                        {{ ins.dob }}
                      </td>

                      <td><span class="badge badge-soft-info">{{ ins.sector }}</span></td>
                      <td>
                        <button
                          class="btn btn-sm btn-outline-info"
                          @click="selectEnrollee(ins)"
                        >
                          <i class="fe fe-eye"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="col-md-5">
            <div class="card table-card shadow mb-4">
              <div class="form-card-header">
                <div class="section-number"><i class="fe fe-user" style="font-size:12px;"></i></div>
                <h6 class="mb-0 font-weight-bold text-white">Enrollee Details</h6>
              </div>
              <div class="card-body">
                <div class="text-center py-4" v-if="selected == ''">
                  <i class="las la-folder-open la-3x text-info text-center"></i>
                  <p class="h5 text-info mt-2">No Enrollee selected Yet</p>
                </div>

                <div class="" v-if="selected != ''">
                  <div class="text-center mb-3">
                    <img
                      :src="`https://claimify-api.hayokmedicare.ng/image/${selected.user_image}`"
                      class="rounded-circle"
                      style="width: 88px; height: 88px; object-fit: cover; border: 3px solid #e2e8f0;"
                      onerror="this.onerror=null; this.src='/kschma_logo.jpg'"
                    />
                  </div>

                  <div class="info-row">
                    <span class="info-label"><i class="fe fe-user info-icon"></i> Full Name</span>
                    <span class="info-value">{{ selected.full_name }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fe fe-credit-card info-icon"></i> Enrollee ID</span>
                    <span class="info-value"><span class="code-chip">{{ selected.id_card_number }}</span></span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fe fe-users info-icon"></i> Type</span>
                    <span class="info-value">{{ selected.account_type }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fe fe-layers info-icon"></i> Sector</span>
                    <span class="info-value">{{ selected.sector }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fe fe-phone info-icon"></i> Phone Number</span>
                    <span class="info-value">{{ selected.phone_number || '—' }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fe fe-gift info-icon"></i> Date of Birth</span>
                    <span class="info-value">{{ selected.dob }} ({{ selected.dob | moment("from", "now") }})</span>
                  </div>
                  <div class="info-row" v-if="selected.place_of_work != null">
                    <span class="info-label"><i class="fe fe-briefcase info-icon"></i> Place of Work</span>
                    <span class="info-value">{{ selected.place_of_work }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fe fe-calendar info-icon"></i> Date of First Appointment</span>
                    <span class="info-value">{{ selected.date_of_entry }} ({{ selected.date_of_entry | moment("from", "now") }})</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fe fe-calendar info-icon"></i> Date of Expiry</span>
                    <span class="info-value">{{ selected.date_of_expiry }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label"><i class="fe fe-trash-2 info-icon"></i> Date of Delete</span>
                    <span class="info-value">{{ selected.deleted_at }}</span>
                  </div>

                  <div class="row mt-4">
                    <div class="col-md-6">
                      <button
                        class="btn btn-success btn-block"
                        @click="date_form = true"
                      >
                        Renew Expiration
                      </button>
                    </div>
                    <div class="col-md-6">
                      <button
                        class="btn btn-danger btn-block"
                        @click="disableUser(selected)"
                      >
                        Disable User
                      </button>
                    </div>
                  </div>

                  <div class="row mt-3" v-show="date_form">
                    <div class="col-md-6">
                      <input
                        type="date"
                        v-model="date_of_expiry"
                        class="form-control"
                      />
                    </div>

                    <div class="col-md-6">
                      <button
                        class="btn btn-success btn-block"
                        @click="enableUser(selected)"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vld-parent">
        <loading
          :active.sync="isLoading"
          loader="dots"
          :can-cancel="true"
          :is-full-page="fullPage"
        ></loading>
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import SectorsJson from "@/jsons/sectors.json";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {

      filterparams: false,
      isLoading: false,
      fullPage: true,
      filter_field: {
        sector: "",
        id_card_number: "",
        from: "",
        to: "",
      },
      sectors: SectorsJson,
      date_form: false,
      lga_states: [],
      info: {
        meta: {},
        data: [],
      },
      selected: "",
      date_of_expiry: "",
      seen: true,
      json_fields: {
        "Full Name": "full_name",
        "ID ": "id_card_number",
        "Phone Number": "phone_number",
        Program: "sector",
        "Date Deleted": "deleted_at",
      },
    };
  },
  methods: {
    getData() {
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/get-expiry-due/407465`)
        .then((response) => {
          this.isLoading = false;
          this.info = response.data;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
    disableUser(selected) {
      if (confirm("Are you Sure?")) {
        this.axios
          .post(`/api/v1/auth/disableUser/` + selected.id)
          .then(() => {
            this.$toasted.info("Deleted Successfully!", {
              position: "top-center",
              duration: 8000,
            });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    enableUser(user) {
      if (confirm("Are you Sure you want to Approve?")) {
        this.axios
          .patch(`/api/v1/auth/extend-expiry/${user.id}`, {
            expiry_date: this.date_of_expiry,
          })
          .then(() => {
            this.$toasted.success("Changed Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.selected = "";
            this.getData();
          })
          .catch((error) => {
            console.error(error);
            alert(error);
          });
      }
    },

    selectEnrollee(enrollee) {
      this.selected = enrollee;
      console.log(this.selected);
    },
    getDeleted() {
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/get-deleted`, {
          agency_id: 407465,
          id_card_number: this.filter_field.id_card_number,
          sector: this.filter_field.sector,
          from: this.filter_field.from,
          to: this.filter_field.to,
        })
        .then((response) => {
          this.info = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.spacer-top-bottom {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
